import * as React from "react";
import type { SVGProps } from "react";
const SvgLuggage01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M8.8 20.1a1 1 0 1 0-2 0h2m-2 1.8a1 1 0 1 0 2 0h-2m9 0a1 1 0 1 0 2 0h-2M10.6 5.7a1 1 0 1 0-2 0h2m-2 10.8a1 1 0 1 0 2 0h-2m6.8-10.8a1 1 0 0 0-2 0h2m-2 10.8a1 1 0 1 0 2 0h-2m-5.6 3.6h-1v1.8h2v-1.8zm9 0h-1v1.8h2v-1.8zM9.6 5.7h-1v10.8h2V5.7zm4.8 0h-1v10.8h2V5.7zM7.2 2.1v1h9.6v-2H7.2zm12 2.4h-1v13.2h2V4.5zm-2.4 15.6v-1H7.2v2h9.6zm-12-2.4h1V4.5h-2v13.2zm2.4 2.4v-1a1.4 1.4 0 0 1-1.4-1.4h-2a3.4 3.4 0 0 0 3.4 3.4zm12-2.4h-1a1.4 1.4 0 0 1-1.4 1.4v2a3.4 3.4 0 0 0 3.4-3.4zM16.8 2.1v1a1.4 1.4 0 0 1 1.4 1.4h2a3.4 3.4 0 0 0-3.4-3.4zm-9.6 0v-1a3.4 3.4 0 0 0-3.4 3.4h2a1.4 1.4 0 0 1 1.4-1.4z"
    />
  </svg>
);
export default SvgLuggage01;
